import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'prefixText',
    standalone: false
})
export class PrefixTextPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let result = value;

    if (args != null && args.value) {
      result = `${args.value} - ${value}`;
    }

    return result;
  }

}
